import _ from 'lodash';
import { ItemEnum, AdjustmentEnum } from 'Common/FieldEnum';
import { StatusAndTypeEnum } from 'Common/Constants/Enumeration/AdjustmentListEnum';
import {getLevelValue} from "Common/FormHelper";

export const basicURL = '/adjustment';
export const getSaveObject = (values, adjustmentId) => {
  let saveObj = {
    Id: adjustmentId,
    SiteId: values[AdjustmentEnum.Site],
    Comments: values[AdjustmentEnum.Comments],
    TransactionDT: values[AdjustmentEnum.TransactionDT],
    Status: StatusAndTypeEnum.Status,
    Type: StatusAndTypeEnum.Type,
    TransactionDetail: [],
  };
  _.forEach(values[AdjustmentEnum.AdjustmentItemsInfo], item => {
    if (item[ItemEnum.PriQtyAdj] || item[ItemEnum.SecQtyAdj]) {
      const obj = {
        Id: adjustmentId,
        SiteId: values[AdjustmentEnum.SiteId],
        ItemId: item[ItemEnum.ItemId],
        ItemCode: item[ItemEnum.ItemCode],
        ItemDescription: item[ItemEnum.Description],
        Unit: item[ItemEnum.Unit],
        SecondaryUnit: item[ItemEnum.SecondaryUnit],
        QtyPerUnit: item[ItemEnum.QtyPerUnit],
        PrimaryQty: item[ItemEnum.PriQtyAdj] ? item[ItemEnum.PriQtyAdj] : 0,
        SecondaryQty: item[ItemEnum.SecQtyAdj] ? item[ItemEnum.SecQtyAdj] : 0,
        PrimaryPrice: item[ItemEnum.Price],
        QtyOnHand: item[ItemEnum.QtyOnHand],
      };
      saveObj.TransactionDetail.push(obj);
    }
  });
  return saveObj;
};
export const dollarCalculationAdj = (itemObj, level1, isGrid) => {
  if (itemObj.PriQtyAdj && !itemObj.SecQtyAdj) {
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(itemObj.PriQtyAdj * level1)
    );
    return isGrid ? levelValue : itemObj.PriQtyAdj * levelValue;
  } else if (itemObj.PriQtyAdj && itemObj.SecQtyAdj) {
    const purchase = +itemObj.SecQtyAdj / itemObj.QtyPerUnit;
    const price = (+itemObj.PriQtyAdj + purchase) * level1;
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(price)
    );
    return isGrid ? levelValue : (+itemObj.PriQtyAdj + purchase) * levelValue;
  } else if (!itemObj.PriQtyAdj && itemObj.SecQtyAdj) {
    const purchase = +itemObj.SecQtyAdj / itemObj.QtyPerUnit;
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(purchase * level1)
    );
    return isGrid ? levelValue : purchase * levelValue;
  }
  return isGrid ? +itemObj.BracketPricingDetails[0].Price : 0;
};

export const quantityCalculationAdj = (itemObj,isGrid)  => {
  if (itemObj.PriQtyAdj && !itemObj.SecQtyAdj) {
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(itemObj.PriQtyAdj)
    );
    return isGrid ? levelValue : itemObj.PriQtyAdj * levelValue;
  } else if (itemObj.PriQtyAdj && itemObj.SecQtyAdj) {
    const purchase = itemObj.SecQtyAdj / itemObj.QtyPerUnit;
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(+itemObj.PriQtyAdj + purchase)
    );
    return isGrid ? levelValue : (+itemObj.PriQtyAdj + purchase) * levelValue;
  } else if (!itemObj.PriQtyAdj && itemObj.SecQtyAdj) {
    const purchase = itemObj.SecQtyAdj / itemObj.QtyPerUnit;
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(purchase)
    );
    return isGrid ? levelValue : purchase * levelValue;
  }
  return isGrid ? +itemObj.BracketPricingDetails[0].Price : 0;
};

export const weightCalculationAdj = (itemObj, isGrid) => {
  if (itemObj.PriQtyAdj && !itemObj.SecQtyAdj) {
    const purchaseQtyPerWeight =
        itemObj.QtyPerUnit * itemObj.SecondaryUnitWeight;
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(+itemObj.PriQtyAdj * purchaseQtyPerWeight)
    );
    return isGrid ? levelValue : +itemObj.PriQty * levelValue;
  } else if (itemObj.PriQtyAdj && itemObj.SecQtyAdj) {
    const purchase = itemObj.SecQtyAdj / itemObj.QtyPerUnit;
    const purchaseQtyPerWeight = itemObj.SecQtyAdj * itemObj.SecondaryUnitWeight;
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round((+itemObj.PriQtyAdj + purchase) * purchaseQtyPerWeight)
    );
    return isGrid ? levelValue : (+itemObj.PriQtyAdj + purchase) * levelValue;
  } else if (!itemObj.PriQtyAdj && itemObj.SecQtyAdj) {
    const purchase = itemObj.SecQtyAdj / itemObj.QtyPerUnit;
    const purchaseQtyPerWeight = itemObj.SecQtyAdj * itemObj.SecondaryUnitWeight;
    const levelValue = getLevelValue(
        itemObj.BracketPricingDetails,
        Math.round(purchase * purchaseQtyPerWeight)
    );
    return isGrid ? levelValue : purchase * levelValue;
  }
  return isGrid ? +itemObj.BracketPricingDetails[0].Price : 0;
};


// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/helper/index.js